<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Stok Warehouse</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-4">
					<v-row>
						<v-col cols="12" md="3">
							<v-autocomplete :items="optionWarehouse" item-text="warehouse_name" v-model="warehouse.value" hide-details class="mt-0" label="Warehouse" outlined dense no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field outlined dense hide-details label="Nama Produk" v-model="name.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field outlined dense hide-details label="Kode Produk" v-model="code.value"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" class="text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
							<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading :headers="headers" :items="listStock" hide-default-footer :options.sync="option" :server-items-length="listStock.total_data" disable-pagination class="table-w-150">
				<template v-slot:item.warehouse_name="{ item }">
					<div class="pt-2">{{ item.warehouse_name }}</div>
				</template>
				<template v-slot:item.product_name="{ item }">
					<div class="pt-2">{{ item.product_name }}</div>
				</template>
				<template v-slot:item.product_code="{ item }">
					<div>{{ item.product_code }}</div>
				</template>
				<template v-slot:item.product_stock_value="{ item }">
					<div>{{ item.product_stock_value }}</div>
				</template>
				<template v-slot:item.product_stock_po_value="{ item }">
					<div>{{ item.product_stock_po_value }}</div>
				</template>
				<template v-slot:item.product_stock_pdo_value="{ item }">
					<div>{{ item.product_stock_pdo_value }}</div>
				</template>
				<template v-slot:item.product_stock_so_value="{ item }">
					<div>{{ item.product_stock_so_value }}</div>
				</template>
				<template v-slot:item.product_stock_sdo_value="{ item }">
					<div>{{ item.product_stock_sdo_value }}</div>
				</template>
				<template v-slot:item.product_stock_to_in_value="{ item }">
					<div>{{ item.product_stock_to_in_value }}</div>
				</template>
				<template v-slot:item.product_stock_to_out_value="{ item }">
					<div>{{ item.product_stock_to_out_value }}</div>
				</template>
				<template v-slot:item.product_stock_tdo_in_value="{ item }">
					<div>{{ item.product_stock_tdo_in_value }}</div>
				</template>
				<template v-slot:item.product_stock_tdo_out_value="{ item }">
					<div>{{ item.product_stock_tdo_out_value }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!stockPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="stockPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="stockPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState,} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			headers: [
			{ text: 'Nama Warehouse', align: 'start', sortable: true,	value: 'warehouse_name'},
			{ text: 'Nama Produk', align: 'start', sortable: true,	value: 'product_name'},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Stok Tersedia', value: 'product_stock_value' },
			{ text: 'Stok PO', value: 'product_stock_po_value' },
			{ text: 'Stok PDO', value: 'product_stock_pdo_value' },
			{ text: 'Stok SO', value: 'product_stock_so_value' },
			{ text: 'Stok SDO', value: 'product_stock_sdo_value' },
			{ text: 'Stok TO In', value: 'product_stock_to_in_value' },
			{ text: 'Stok TO Out', value: 'product_stock_to_out_value' },
			{ text: 'Stok TDO In', value: 'product_stock_tdo_in_value' },
			{ text: 'Stok TDO Out', value: 'product_stock_tdo_out_value' },
			],
			warehouse: {
				value:'',
				comparison:'=',
				type:'string',
				field:'warehouse_name'
			},
			code: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_code'
			},
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_name'
			},
			params:[],
		}
	},
	computed: {
		...mapState('stock', ['listStock', 'stockPagination', 'optionWarehouse']),
	},
	methods: {
		...mapActions('stock', ['getStockAll', 'exportStockAll', 'getOptionWarehouse']),

		getData() {
			this.getStockAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			this.exportStockAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		cari() {
			this.params= []

			if(this.code.value)
				this.params.push(this.code)

			if(this.name.value)
				this.params.push(this.name)

			if(this.warehouse.value)
				this.params.push(this.warehouse)

			this.getData()
		},
		resetFilter() {
			this.code.value = ''
			this.name.value = ''
			this.params = []
			this.limit = 10
			this.getData()
		},
	},
	created() {
		this.getData()
		this.getOptionWarehouse()
		this.$store.dispatch('setPageTitle', `Stok Warehouse`)
	},
	watch: {
		page() {
			this.getData()
		},
		limit() {
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>